<template>
  <div
    ref="contextMenuItem"
    class="context-menu__item"
    :class="[
      hasChildren ? 'context-menu__item--has-children' : '',
      icon ? '' : 'context-menu__item--no-icon'
    ]"
    @mouseenter="mouseenter"
    @mouseleave="mouseleave"
  >
    <p4a-icon
      v-if="icon"
      :icon="icon"
      class="context-menu__item--icon"
    />

    <p4a-icon
      v-if="hasChildren"
      :icon="'chevron-corner'"
      class="context-menu__item--has-children--chevron"
    />

    <div
      @click="click"
      :class="{ 'context-menu__item--has-divider': divider }"
    >
      {{ label }}
    </div>

    <p4a-context-menu
      v-if="hasChildren && contextMenuVisible"
      :child-context-menu="true"
      :passed-flow-direction="$parent.flowDirection"
      :x="relativeX"
      :y="relativeY"
    >
      <slot />
    </p4a-context-menu>
  </div>
</template>

<script>
import { filter } from 'lodash'

export default {
  props: {
    label: {
      type: String,
      required: true
    },

    icon: {
      type: String,
      default: null
    },

    divider: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      contextMenu: 'hidden',
      contextMenuVisible: false
    }
  },

  computed: {
    index () {
      const validSiblings = filter(this.$parent.$children, component => component)

      return validSiblings.indexOf(this)
    },

    relativeX () {
      return this.$el.offsetWidth
    },

    // Find the relativeY position (compared to the context menu) using the location compared to the siblings
    relativeY () {
      return this.$el.offsetHeight * this.index
    },

    hasChildren () {
      return typeof this.$slots.default !== 'undefined'
    }
  },

  methods: {
    // Find the own vnode compared to the parent child vnodes, who are visible
    findIndexOfSiblings () {
      const validSiblings = filter(this.$parent.$children, component => component)

      return validSiblings.indexOf(this)
    },

    // On click show context menu and emit click listener
    click () {
      this.$emit('click')
    },

    mouseenter () {
      const self = this

      this.contextMenu = 'visible'

      setTimeout(() => {
        if (self.contextMenu === 'visible') {
          self.contextMenuVisible = true
        }
      }, 300)
    },

    mouseleave () {
      const self = this

      this.contextMenu = 'hidden'

      setTimeout(() => {
        if (self.contextMenu === 'hidden') {
          self.$parent.$el.focus()
          self.contextMenuVisible = false
        }
      }, 300)
    }
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/ui-kit/components/ContextMenu/ContextMenuItem.vue